<template>
    <b-container class="p-5">
        <b-row class="mb-4">
            <b-col class=" px-0">
                <h6 class="text-muted text-monospace">
                    Instructions
                </h6>

            </b-col>
        </b-row>
        <b-row>
            <b-col class="px-0">
                <b-alert show variant="info" class="text-monospace">
                    01. <span v-html="$t('modal.help.zoom')"></span>
                </b-alert>
                <b-alert show variant="info" class="text-monospace">
                    02. <span v-html="$t('modal.help.drag')"></span>
                </b-alert>
                <b-alert show variant="info" class="text-monospace">
                    03. <span v-html="$t('modal.help.esc')"></span>
                </b-alert>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
export default {
    name: "InfoModal",
}
</script>